const UNAUTHORIZED = 401


/**
 * Reports whether a failed request was refused for want of a credential the
 * server would accept, as opposed to failing for any other reason.
 *
 * A request that never reached a server carries no response at all, and that
 * says nothing about who the person is, so it is not treated as a refusal.
 *
 * @param {Object} [error] - the error the request rejected with, absent when
 *   it did not fail
 * @param {Object} [error.response] - the server's answer
 * @param {Number} [error.response.status]
 *
 * @returns {Boolean} whether the server refused the credential
 */
export default function isUnauthorized(error) {
  return error?.response?.status === UNAUTHORIZED
}
